/**
 * Keeps every cart-count badge on the page in sync after any cart change
 * (add / update / remove), without a full page reload.
 *
 * The theme's own cart scripts don't reliably refresh the header badges
 * (desktop header + PDP mobile header) after an AJAX cart mutation, so this
 * listens at the network layer for any request to a cart-mutating endpoint
 * and re-renders the badges from fresh server data once it completes.
 */
(function () {
  'use strict';

  var CART_MUTATION_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartMutationUrl(url) {
    try {
      var path = new URL(url, window.location.href).pathname;
      return CART_MUTATION_PATHS.some(function (mutationPath) {
        return path.indexOf(mutationPath) !== -1;
      });
    } catch (error) {
      return false;
    }
  }

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function setSimpleBubble(anchor, count) {
    var existing = anchor.querySelector('.cart-count-bubble');

    if (count > 0) {
      if (!existing) {
        existing = document.createElement('span');
        existing.className = 'cart-count-bubble';
        anchor.appendChild(existing);
      }

      var numberSpan = existing.querySelector('span[aria-hidden], span');

      if (!numberSpan) {
        numberSpan = document.createElement('span');
        existing.appendChild(numberSpan);
      }

      numberSpan.textContent = count;
    } else if (existing) {
      existing.remove();
    }
  }

  function updateSimpleBadges(itemCount) {
    document.querySelectorAll('[data-cart].pdp-cart').forEach(function (anchor) {
      setSimpleBubble(anchor, itemCount);
    });
  }

  function updateHeaderCartIconBubble() {
    var target = document.getElementById('cart-icon-bubble');

    if (!target) {
      return;
    }

    var sectionUrl =
      window.location.pathname +
      (window.location.search ? window.location.search + '&' : '?') +
      'sections=cart-icon-bubble';

    fetch(sectionUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];

        if (!html) {
          return;
        }

        var parsedSection = new DOMParser().parseFromString(html, 'text/html');
        var content = parsedSection.querySelector('.shopify-section');

        if (content) {
          target.innerHTML = content.innerHTML;
        }
      })
      .catch(function () {});
  }

  function refreshCartBadges() {
    fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) {
          updateSimpleBadges(cart.item_count);
        }
      })
      .catch(function () {});

    updateHeaderCartIconBubble();
  }

  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var request = nativeFetch.apply(this, arguments);

    if (url && isCartMutationUrl(url)) {
      request.then(function (response) {
        if (response && response.ok) {
          refreshCartBadges();
        }
      }).catch(function () {});
    }

    return request;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartMutation = isCartMutationUrl(url);
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartMutation) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          refreshCartBadges();
        }
      });
    }

    return nativeSend.apply(this, arguments);
  };
})();
